import { set, format, getHours, getMinutes, isAfter, isEqual, isDate, toDate, intervalToDuration, formatDistanceStrict } from 'date-fns';
import _ from 'lodash';
import moment from 'moment-timezone'

import { tagContext } from 'context'
import { Alert, Schedule, Tag, Page, Section, Item, Client, ClientWorkflow } from 'schema'
import { 
    EditorState, 
    ContentState,
} from 'draft-js';

export const childHandler = (itemID, item, status_list) => {
    // console.log(item)
    let result = {keys: [], nodes: []}
    const item_details = item['item_details']
    const childrenIDs = item_details['item_children']
    const item_children = item['item_children']
    const show_children = item_details['children_visibility']
    result['keys'].push(itemID)
    result['nodes'].push(item)
    status_list.map((status, index) => {
        if(childrenIDs){
            if(childrenIDs[status] && show_children){
                for(const childID of Object.values(childrenIDs[status])) {
                    const child = item_children[childID]
                    const int_result = childHandler(childID, child, status_list)
                    result['keys'] = result['keys'].concat(int_result['keys'])
                    result['nodes'] = result['nodes'].concat(int_result['nodes'])
                }
            }
        }
    })
    return result
}

export const initData = data => {
    let updatedData = {
        alerts: {},
        schedules: {},
        tags: {},
        pages: {},
        sections: {},
        items: {},
        clients: {},
        workflows: {}
    }
    // console.log('[DATA HERE]', data)
    updatedData['alerts'] = !data['alerts'] ? {} : Object.keys(data['alerts']).length > 0 ? Object.assign(...Object.keys(data['alerts']).map((k, i) => ({[k]: new Alert({...data['alerts'][k], alertID: k})}))) : {}
    // updatedData['schedules'] = !data['schedules'] ? {} : Object.keys(data['schedules']).length > 0  ? Object.assign(...Object.keys(data['schedules']).map((k, i) => ({[moment(k).format('MMM D Y')]: new Schedule({...data['schedules'][k], scheduleID: data['schedules'][k]['_id']})}))) : {}
    updatedData['tags'] = !data['tags'] ? {} : Object.keys(data['tags']).length > 0  ? Object.assign(...Object.keys(data['tags']).map((k, i) => ({[k]: new Tag({...data['tags'][k], tagID: k})}))) : {}
    updatedData['pages'] = !data['pages'] ? {} : Object.keys(data['pages']).length > 0  ? Object.assign(...Object.keys(data['pages']).map((k, i) => ({[k]: new Page({...data['pages'][k], pageID: k})}))) : {}
    updatedData['sections'] = !data['sections'] ? {} : Object.keys(data['sections']).length > 0  ? Object.assign(...Object.keys(data['sections']).map((k, i) => ({[k]: new Section({...data['sections'][k], sectionID: k})}))) : {}
    updatedData['items'] = !data['items'] ? {} : Object.keys(data['items']).length > 0  ? Object.assign(...Object.keys(data['items']).map((k, i) => ({[k]: new Item({...data['items'][k], itemID: k})}))) : {}
    updatedData['clients'] = !data['clients'] ? {} : Object.keys(data['clients']).length > 0  ? Object.assign(...Object.keys(data['clients']).map((k, i) => ({[k]: new Client({...data['clients'][k], id: k})}))) : {}
    updatedData['workflows'] = !data['workflows'] ? {} : Object.keys(data['workflows']).length > 0  ? Object.assign(...Object.keys(data['workflows']).map((k, i) => ({[k]: new ClientWorkflow({...data['workflows'][k], id: k})}))) : {}


    return updatedData
}

export const socketUpdates = payload => {
    const debug = false;
    const data = payload['data']
    debug && console.log('[socketUpdate]', payload)

    let updatedData = {...data}
    const collection = payload.ns['coll']
    const operationType = payload['operationType'] // insert, update, delete

    switch(collection){
        case 'items':
            const itemID = payload.documentKey['_id']
            if(['insert','update'].includes(operationType)){
                const item = new Item(payload['fullDocument'])
                updatedData.items[itemID] = item
            } else if (['delete'].includes(operationType)){
                delete updatedData.items[itemID]
            }
            break
        case 'sections':
            const sectionID = payload.documentKey['_id']
            if(['insert','update'].includes(operationType)){
                const section = new Section(payload['fullDocument'])
                updatedData.sections[sectionID] = section
            } else if (['delete'].includes(operationType)){
                delete updatedData.sections[sectionID]
            }
            break
        case 'pages':
            const pageID = payload.documentKey['_id']
            if(['insert','update'].includes(operationType)){
                const page = new Page(payload['fullDocument'])
                updatedData.pages[pageID] = page
            } else if (['delete'].includes(operationType)){
                delete updatedData.pages[pageID]
            }
            break
    }

    return updatedData
}

export const datetimeString = (value) => {
    const date = new Date(value)
    let type = date.getHours() === 0 & date.getMinutes() === 0 & date.getSeconds() === 0 & date.getMilliseconds() === 0 ? 'day' : 'time'

    const formatString = type === 'item' ? 'yyyy-MM-dd HH:mm:ss'
                : type === 'day' ? 'eee, MMM d yyyy' 
                : type === 'time' ? 'eee, MMM d yyy (h:mm aaaa)'
                : 'yyyy-MM-dd HH:mm:ss'
    let updatedValue = value;
    if(updatedValue){
        updatedValue = new Date(updatedValue)
        updatedValue.setSeconds(0,0)
        updatedValue = format(updatedValue, formatString).toString();
    }
    return updatedValue;
}

export const formatDateTime = (value) => {
    // Accepts moment only
    const type = value.hours() === 0 & value.minutes() === 0 & value.seconds() === 0 ? 'day' : 'time'
    const format = type === 'day' ? 'ddd D MMM Y'
                : type === 'time' ? 'ddd D MMM Y (h:mma)'
                : null
    return format && value.format(format)
    
}

export const formatItemDatetime = (item_details) => {
    let updatedItemDetails = {...item_details};
    const dateKeys = ['start_date', 'end_date', 'start_time', 'end_time', 'create_date', 'completed_date'];
    dateKeys.map(dateKey => {
        if(updatedItemDetails[dateKey]){
            updatedItemDetails[dateKey] = datetimeString(updatedItemDetails[dateKey]);
        }
    })
    return updatedItemDetails;
}

export const getParent = (data, item) => {
    const parents = Object.values(item['item_details']['parents'])
    const pageID =item['item_details']['pageID']
    const sectionID = item['item_details']['sectionID']
    const section_items = data['pages'][pageID]['sections'][sectionID]['section_items']
    let aux = {...section_items};
    parents.map(parent => {
        if(parent !== parents.slice(-1)[0]){
            if(aux[parent]['item_children']){
                aux = aux[parent]['item_children']
            }
        } else {
            aux = aux[parent]
        }
        // if(aux[parent]['item_children'] && parent !== parents.slice(-1)[0]){
        //     aux = aux[parent]['item_children']
        // } else {
        //     aux = aux[parent]
        // }
    })
    return aux
}

export const updateChildrenParents = (childrenData, oldParents, newParents, sectionID) => {
    let updatedData = {...childrenData}

    if(!updatedData.item_children) {
        // end the loop
        Object.keys(updatedData).map((childID, index) => {
            updatedData[childID]['item_details']['parents'] = newParents.concat(Object.values(updatedData[childID]['item_details']['parents']).filter(parentID => !oldParents.includes(parentID)))
        })
        return
        
    } else {
        // recurse this shit
        const incompletedChildrenKeys = updatedData.item_details.item_children.INCOMPLETE ? Object.values(updatedData.item_details.item_children.INCOMPLETE) : [];
        const completedChildrenKeys = updatedData.item_details.item_children.COMPLETED ? Object.values(updatedData.item_details.item_children.COMPLETED) : [];
        const childrenKeys = incompletedChildrenKeys.concat(completedChildrenKeys)
        childrenKeys.map((childrenID, index) => {
            let childData = updatedData.item_children[childrenID]
            childData['item_details']['parents'] = newParents.concat(Object.values(childData['item_details']['parents']).filter(parentID => !oldParents.includes(parentID)))
            childData['item_details']['sectionID'] = sectionID
            if(childData.item_children) {
                updateChildrenParents(childData.item_children, oldParents, newParents)
            }
        })
    }
    return updatedData
}

const updateChildrenParentsOld = (childrenData, oldParents, newParents, sectionID) => {
    if(!childrenData.item_children) {
        // end the loop
        Object.keys(childrenData).map((childID, index) => {
            childrenData[childID]['item_details']['parents'] = newParents.concat(Object.values(childrenData[childID]['item_details']['parents']).filter(parentID => !oldParents.includes(parentID)))
        })
        return
        
    } else {
        // recurse this shit
        const incompletedChildrenKeys = childrenData.item_details.item_children.INCOMPLETE ? Object.values(childrenData.item_details.item_children.INCOMPLETE) : [];
        const completedChildrenKeys = childrenData.item_details.item_children.COMPLETED ? Object.values(childrenData.item_details.item_children.COMPLETED) : [];
        const childrenKeys = incompletedChildrenKeys.concat(completedChildrenKeys)
        childrenKeys.map((childrenID, index) => {
            let childData = childrenData.item_children[childrenID]
            childData['item_details']['parents'] = newParents.concat(Object.values(childData['item_details']['parents']).filter(parentID => !oldParents.includes(parentID)))
            childData['item_details']['sectionID'] = sectionID
            if(childData.item_children) {
                updateChildrenParents(childData.item_children, oldParents, newParents)
            }
        })
    }
}

export const dropAlgorithm = (item, itemBefore, itemAfter) => {
    let droppableStatus = [];
    let droppableParents = [];
    const itemParents = item.parents.length === 0 ? [] : Object.values(item.parents)
    const itemBeforeParents = !itemBefore ? [] 
                            : itemBefore.parents.length === 0 ? []
                            : Object.values(itemBefore.parents)
    const itemAfterParents = !itemAfter ? []
                            : itemAfter.parents.length === 0 ? []
                            : Object.values(itemAfter.parents)                
    // console.log({item: itemParents, itemBefore: itemBeforeParents, itemAfter: itemAfterParents})
    const print = false
    // First item
    if(!itemBefore) {
        droppableStatus.push(true)
        // droppableStatus.push(false)
        droppableParents.push(item.itemID);
        if(print){console.log('first item', droppableParents, droppableStatus)}
    } 
    // Last item
    else if (!itemAfter){
        itemBeforeParents.map((parentID, index) => {
            droppableStatus.push(true);
            droppableParents.push(parentID);
            })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID)
        if(print){console.log('last item',droppableParents, droppableStatus, {before: itemBefore['itemID'], current: item['itemID']})}
    }
    // Same level
    else if(itemParents.length === itemBeforeParents.length && itemParents.length === itemAfterParents.length){
        if(itemBeforeParents) {
            itemBeforeParents.map((parentID, index) => {
                droppableStatus.push(false);
                droppableParents.push(parentID);
                })
        } 
        droppableStatus.push(true)
        droppableParents.push(itemBefore.itemID);
        droppableStatus.push(true)
        if(print){console.log('Same level', droppableParents, droppableStatus)}
    } 
    // Before > Current > After
    else if (itemParents.length < itemBeforeParents.length && itemParents.length > itemAfterParents.length){
        itemBeforeParents.map((parentID, index) => {
            droppableParents.push(parentID);
            droppableStatus.push(true);
        })
        droppableStatus.push(true)
        droppableStatus.push(true)
        droppableParents.push(itemBefore.itemID)
        if(print){console.log('Before > Current > After', droppableParents, droppableStatus)}
    } 
    // Before < Current < After
    else if (itemParents.length > itemBeforeParents.length && itemParents.length < itemAfterParents.length){
        itemBeforeParents.map((parentID, index) => {
            droppableParents.push(parentID);
            droppableStatus.push(false);
        })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID)
        if(print){console.log('Before < Current < After', droppableParents, droppableStatus)}
    } 
    // Before < Current > After
    else if (itemParents.length > itemBeforeParents.length && itemParents.length > itemAfterParents.length){
        itemBeforeParents.map((parentID, index) => {
                droppableParents.push(parentID)
                droppableStatus.push(false);
            })
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID)
        droppableStatus.push(true);
        if(print){console.log('Before < Current > After', droppableParents, droppableStatus)}
    } 
    // Before > Current < After
    else if (itemParents.length < itemBeforeParents.length && itemParents.length < itemAfterParents.length){
            itemBeforeParents.map((parentID, index) => {
                droppableParents.push(parentID);
                droppableStatus.push(true);
            })
            droppableStatus.push(true);
            droppableParents.push(itemBefore.itemID);
            if(print){console.log('Before > Current < After', droppableParents, droppableStatus)}
    } 
    // Before > Current = After
    else if ((itemParents.length > itemBeforeParents.length) && (itemParents.length === itemAfterParents.length)){
        itemBeforeParents.map((parentID, index) => {
            droppableStatus.push(false);
            droppableParents.push(parentID);
        })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID)
        if(print){console.log('Before > Current = After', droppableParents, droppableStatus)}
    } 
    // Before === Current > After
    else if ((itemParents.length === itemBeforeParents.length) && (itemParents.length > itemAfterParents.length)){
        itemBeforeParents.map((parentID, index) => {
            droppableStatus.push(true);
            droppableParents.push(parentID);
        })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID);
        if(print){console.log('Before === Current > After', droppableParents, droppableStatus)}
    }
    // Before < Current = After
    else if ((itemParents.length < itemBeforeParents.length) && (itemParents.length === itemAfterParents.length)){
        itemBeforeParents.map((parentID,index) => {
            droppableParents.push(parentID);
            if(itemParents.includes(parentID)) {
                droppableStatus.push(false);
            } else {
                droppableStatus.push(true);
            }
        })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID);
        if(print){console.log('Before < Current = After',droppableParents, droppableStatus)}
    } 
    // Before === Current < After'
    else if ((itemParents.length === itemBeforeParents.length) && (itemParents.length < itemAfterParents.length)){
        itemBeforeParents.map((parentID, index) => {
            droppableStatus.push(false);
            droppableParents.push(parentID);

        })
        droppableStatus.push(true);
        droppableStatus.push(true);
        droppableParents.push(itemBefore.itemID);
        if(print){console.log('Before === Current < After', droppableParents, droppableStatus)}
    }

    else {
        if(print){console.log('NO CASE')};
    }
    
    let result = {
        'dropStatus': droppableStatus,
        'dropIDs': droppableParents
    }
    return result
}

export const randomTagColor = (theme, excludeList) => {
    let colorsCodes = Object.values(tagContext[theme])
    let colorsNames = Object.keys(tagContext[theme])
    if(excludeList){
        if(excludeList['colors'].length !== 10){
            colorsCodes = _.difference(colorsCodes, excludeList.colors);
            colorsNames = _.difference(colorsCodes, excludeList.names);
        }
    }
    
    const randomIndex = Math.floor(Math.random()*colorsCodes.length)
    const randomColorCode = colorsCodes[randomIndex]
    const randomColorName = colorsNames[randomIndex]
    return {randomColorCode, randomColorName}
}

export const scheduleString = (values, timezone, output) => {
    let start_date = values['start_date'] && momentDate(values['start_date'], timezone)
    let end_date = values['end_date'] && momentDate(values['end_date'], timezone)
    const start_time = values['start_time'] && momentDate(values['start_time'], timezone)
    const end_time = values['end_time'] && momentDate(values['end_time'], timezone)
    let start = null;
    let end = null;

    if(start_date && end_date){ // Both dates
        if(start_date.format('D/M/Y') === end_date.format('D/M/Y')){ // Same dates
            // Start & end time
            if(start_time && end_time){ 
                start = `${start_date.format('ddd D/M')} ${start_time.format('h:mma')}`
                end = `${end_time.format('h:mma')}`
            } 
            // Start or end time
            else if (start_time || end_time){ 
                start = start_time ? `${start_date.format('ddd D/M')} ${start_time.format('h:mma')}` 
                        : `${start_date.format('ddd D/M')} ${end_time.format('h:mma')}`
                end = null
            } 
            // No time
            else {
                start = start_date.format('ddd D/M')
            }

        } else { // Different dates
            start = start_time ? `${start_date.format('ddd D/M')} ${start_time.format('h:mma')}` : start_date.format('ddd D/M')
            end = end_time ? `${end_date.format('ddd D/M')} ${end_time.format('h:mma')}` : end_date.format('ddd D/M')
        }
    } 
    else if(start_date || end_date){ 
        // 1 day and both times
        if(start_time && end_time){
            start = start_date ? `${start_date.format('ddd D/M')} ${start_time.format('h:mma')}` : `${end_date.format('ddd D/M')} ${start_time.format('h:mma')}`
            end = start_date ? `${start_date.format('ddd D/M')} ${end_time.format('h:mma')}` : `${end_date.format('ddd D/M')} ${end_time.format('h:mma')}`
        } 
        // 1 date and 1 time
        else if (start_time || end_time) { 
            const time = start_time ? start_time.format('h:mma') : end_time.format('h:mma')
            const date = start_date ? start_date.format('ddd D/M') : end_date.format('ddd D/M')
            start = date + ' ' + time;
        } else {
            start = start_date ? start_date.format('ddd D/M') : end_date.format('ddd D/M')
        }
    } else { // No date

    }

    // Check validity
    let valid = true;
    if(start_date & end_date){
        if(start_date.format('D-M-Y') === end_date.format('D-M-Y')){
            valid = true
        } else {
            if(!end_date.isAfter(start_date)){
                valid = false
            } 
        }
    } else if (start_time & end_time){
        if(!end_time.isAfter(start_time)){
            valid = false
        }
    }

    if(!start_time & !end_time & !start_date & !end_date){
        valid = false
    }
    if(output === 'string'){
        const result = !end ? start
                    : start === end ? end
                    : `${start} - ${end}`;
        return result
    } else {
        const result = start === end ? {start: null, end: end, valid: valid} : {start: start, end:end, valid: valid};
        return result
    }
    
}

export const alertConverter = (refDate, targetDate) => {
    let type = refDate.getHours() === 0 & refDate.getMinutes() === 0 & refDate.getSeconds() === 0 & refDate.getMilliseconds() === 0 ? 'day' : 'time'
    const options = type === 'day' ? ['weeks', 'days']
                    : type === 'time' ? ['days', 'hours', 'minutes']
                    : null
    const distance = refDate - targetDate === 0 ? 'At event time' : `${formatDistanceStrict(refDate, targetDate)} before`
    if(!options){
        return null
    } else {
        return distance
    }
}

export const getPlainText = (json) => {
    const blocks = JSON.parse(json)['blocks']
    let value = blocks.map(block => (!block.text.trim() && '\n') || block.text).join('\n');
    value = value.toString().trim()
    return value
} 

export const getItem = (itemID, sectionID, pageID, parents, data) => {
    let aux = {...data['pages'][pageID]['sections'][sectionID]['section_items']};
    console.log({itemID: itemID, sectionID: sectionID, pageID: pageID, parents: parents, data: data})
    if(parents){
        Object.values(parents).map(parent => {
            if(aux[parent]['item_children'] && parent !== parents.slice(-1)[0]){
                aux = aux[parent]['item_children']
            } else {
                aux = aux[parent]['item_children'][itemID]
            }
        })
    } else {
        aux = aux[itemID]
    }
    return aux
}

export const fileValidation = (file, rules = {fileTypes: ['image'],sizeLimit: 4000000,}) => {
    let valid = true;
    let error = null;
    const fileType = file ? file.type.split('/')[0] : null;
    const fileSize = file ? file.size : null;
    if(Object.keys(rules).length > 0){
        for (const [ruleName, ruleDef] of Object.entries(rules)) {
            if(ruleName === 'fileTypes'){
                if(!ruleDef.includes(fileType)){
                    valid = false;
                    error = 'Invalid file type';
                }
            } else if (ruleName  === 'sizeLimit'){
                if(fileSize > ruleDef){
                    valid = false;
                    error = 'File too large';
                }
            }
        }
    }
    const result = {valid: valid, error: error};
    return result
}

export const prettyString = value => {
    let strings = value.split(' ')
    strings = strings.map(text => ((text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()).replace('_', ' ')))
    return strings.join(' ')
}

//////////////////////
// Timezone helpers //
//////////////////////
export const momentDate = (date, timezone, isDate) => {
    if(isDate){
        let updatedDate = moment(moment(date).format("YYYY-MM-DD HH:mm:ss")).tz(timezone)
        updatedDate.set({hour: 0, minute: 0, second: 0})
        return updatedDate
    } else {
        return moment(moment(date).format("YYYY-MM-DD HH:mm:ss")).tz(timezone)
    }
    
}

export const timezoneDate = (date, timeZoneName) => {
    // const dateM = moment.tz(date, timeZoneName);
    const dateM = moment(date)
    return moment.tz({
        year: dateM.year(),
        month: dateM.month(),
        date: dateM.date(),
        hour: dateM.hour(),
        minute: dateM.minute(),
    }, timeZoneName);
};

export const getTimezones = () => {
    let offsetTmz=[];
    let timeZones = moment.tz.names();
    for(var i in timeZones){
        offsetTmz.push("(GMT"+moment.tz(timeZones[i]).format('ZZ')+") " + timeZones[i]);
    }
    offsetTmz = offsetTmz.sort()
    let tzOptions = {}
    offsetTmz.map(tz => {
        const parts = tz.split(' ')
        tzOptions[parts[1]] = tz
    })

    return tzOptions
}

export const getInputID = (id) => {
    const components = id.split('_')
    return `${components[0]}_${components[1]}`
}

export const queryToDate = (value, timezone) => {
    const format = 'YYYY-MM-DD'
    let output
    if(value.includes('today') || value.includes('upcoming') || value.includes('calendar')){
        output = moment().tz(timezone)
    } else if (value.includes('yesterday')){
        output = moment().tz(timezone).subtract({days: 1})
    } else if (value.includes('tomorrow')){
        output = moment().tz(timezone).add({days: 1})
    } else if(moment(value)._isValid){
        output = moment(value)
    } 

    if(output){
        return {
            $gte: output.startOf('day').toDate(),
            $lte: output.endOf('day').toDate()
        }
    } else {
        return null
    }
}

///////////////////////
// RICH TEXT HELPERS //
///////////////////////
export const richTextify = (raw) => {
    return ContentState.createFromText(raw)
}